import { useFormik } from "formik";
import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { ResetPasswordSchema } from "../../../Schena/ResetPassword";
import { ModifyPassword } from "../../../Services/StoreHub";
import { toast } from "react-toastify";

const ResetPassword = ({ store, onClose }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const formik = useFormik({
    initialValues: {
      new_password: "",
      confirm_password: "",
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: async (values) => {
      try {
        const res = await ModifyPassword({
          store_id: store?.id,
          new_password: values.new_password,
          confirm_password: values.confirm_password,
        });
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.messsage);
        } else {
          toast.warn(res?.data?.messsage);
        }
        onClose();
      } catch (err) {
        throw new Error(err);
      }
    },
  });
  return (
    <div>
      <div className="max-w-md mx-auto p-6 bg-white rounded shadow">
        <p className="text-xl font-bold pb-4 text-gray-800">
          Reset Password for {store.store_name || "Store"}
        </p>

        <form onSubmit={formik.handleSubmit}>
          <div>
            <label
              className="block text-gray-700 font-medium mb-1"
              htmlFor="password"
            >
              New Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="new_password"
                name="new_password"
                onChange={formik.handleChange}
                value={formik.values.new_password}
                placeholder="Create New Password"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                tabIndex={-1}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {formik.touched.new_password && formik.errors.new_password && (
              <p className="text-red-500 text-sm mt-1">
                {formik.errors.new_password}
              </p>
            )}
          </div>

          <div>
            <label
              className="block text-gray-700 font-medium pt-2 mb-1"
              htmlFor="password"
            >
              Confirm Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="confirm_password"
                name="confirm_password"
                onChange={formik.handleChange}
                value={formik.values.confirm_password}
                placeholder="Create New Password"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                tabIndex={-1}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {formik.touched.confirm_password &&
              formik.errors.confirm_password && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.confirm_password}
                </p>
              )}
          </div>

          <div className="flex space-x-4 pt-4">
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Reset Password
            </button>
            <button
              type="button"
              onClick={onClose}
              className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
